import React, { useEffect, useState } from 'react';
import Logo from './Logo';

// One size, everywhere — including App.jsx's boot/login gate, which used
// to get its own separate big-glow "hero" treatment. That read as a
// different, heavier product from the same small mark used on ordinary
// in-app navigation; this is the same calm loading state used in all
// ~40 other places, just the one design.
// syncNote (Overblik only): data that is stored is shown at once, so a wait of more than a moment means the data is being read
// from Microsoft (first time, or the stored data has expired). Only then is that said.
// The same note as a line on a page that is already on screen but still waiting for data (Overblik shows … in its figures).
export function SyncNote() {
  const [slow, setSlow] = useState(false);
  useEffect(() => { const timer = setTimeout(() => setSlow(true), 1500); return () => clearTimeout(timer); }, []);
  if (!slow) return null;
  return <p className="sync-note" role="status"><b>Synkroniserer med Microsoft 365…</b> Kan tage et øjeblik</p>;
}

export default function LoadingState({ syncNote = false }) {
  const [slow, setSlow] = useState(false);
  useEffect(() => {
    if (!syncNote) return undefined;
    const timer = setTimeout(() => setSlow(true), 1500);
    return () => clearTimeout(timer);
  }, [syncNote]);
  return (
    <div className="loading-overlay" role="status" aria-label="Indlæser">
      <div className="loading-overlay__content">
        <Logo size={80} animated className="loading-overlay__logo" />
        {slow && (
          <>
            <div className="loading-overlay__title">Synkroniserer med Microsoft 365…</div>
            <div className="loading-overlay__sub">Kan tage et øjeblik</div>
          </>
        )}
      </div>
    </div>
  );
}
